/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DataVaxiomInsuranceBillingCenter from 'DesignSystem/DataVaxiomInsuranceBillingCenter/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/BillingCenter/Content/Options/Create/Content"
  
}) {
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="small"
 height="auto"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<TysiaHeading
{...childProps}
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Add Billing Center"
/>
)}
</TysiaModalHeader>
<DataVaxiomInsuranceBillingCenter
{...childProps}
  viewPath={`${viewPath}/DataVaxiomInsuranceBillingCenter`}
/>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}